export class TaskCategoryEnum {
    public static QR = { symbol: 'QR', name: 'Quotation Request', id: 1 };
    public static IR = { symbol: 'IR', name: 'Internal Request', id: 2 };
    public static BR = { symbol: 'BR', name: 'Bug Request', id: 3 };
    public static SR = { symbol: 'SR', name: 'Service Request', id: 4 };
    public static ER = { symbol: 'ER', name: 'Emergency Request', id: 5 };
    public static CR = { symbol: 'CR', name: 'Change Request', id: 6 };
    public static RELEASE = { symbol: 'RELEASE', name: 'Release', id: 7 };
}